// src/lib/permissions.ts
import type { AdminRole } from '../features/auth/auth-storage';

type Role = AdminRole | undefined;

export function canReadAudit(role: Role): boolean {
  return ['SUPER_ADMIN'].includes(role ?? '');
}
